export default __webpack_public_path__ + "static/media/section21.3d83f2a7.svg";